<p-table #table id="{{tableId}}" dataKey="rowId" [columns]="selectedColumns" [value]="data" (onFilter)="onFilter($event)"
         [sortMode]="'multiple'" [loading]="loading" [multiSortMeta]="multiSortMeta" [rows]="10" (onSort)="onSort($event)"
         [paginator]="paginator" [rowsPerPageOptions]="rowsPerPageOptions" [globalFilterFields]="globalFilterFields"
         [lazy]="lazy" [lazyLoadOnInit]="lazyLoadOnInit" (onLazyLoad)="onLazyLoad($event)" [totalRecords]="totalRecords"
         (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" [(selection)]="selection" (selectionChange)="onSelectionChange($event)"
         [metaKeySelection]="true" [resizableColumns]="true"
         [selectionMode]="selectionMode"
         styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-hoverable-rows">

  <ng-template *ngIf="showCaption" pTemplate="caption">

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-4 xl:col-4">
        <div class="flex align-self-start">

          <ng-container *ngTemplateOutlet="captionLeftContentPrefix"></ng-container>
          <ng-container *ngIf="captionLeftContent; then hasCaptionLeftContent else noCaptionLeftContent"></ng-container>
          <ng-template #hasCaptionLeftContent>
            <ng-container *ngTemplateOutlet="captionLeftContent"></ng-container>
          </ng-template>

        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-3 xl:col-3">

        <ng-template #noCaptionLeftContent>
          <div class="p-inputgroup">
            <input #globalFilter type="text" pInputText size="25" placeholder="Filter" (input)="filterGlobal($any($event).target.value)" aria-label="Filter" />
            <span class="p-inputgroup-addon">
              <span class="pi pi-filter"></span>
            </span>
          </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="captionLeftContentSuffix"></ng-container>
      </div>

      <div class="col-12 md:col-12 lg:col-2 xl:col-2">
        <ng-container *ngTemplateOutlet="captionRightContentPrefix"></ng-container>
      </div>

      <div class="col-12 md:col-12 lg:col-3 xl:col-3">
        <div class="flex-1">
          <ng-container *ngIf="captionRightContent; then hasCaptionRightContent else noCaptionRightContent"></ng-container>
        </div>
      </div>

      <ng-template #hasCaptionRightContent>
        <ng-container *ngTemplateOutlet="captionRightContent"></ng-container>
      </ng-template>

      <ng-template #noCaptionRightContent>
        <label id="{{colSelectId}}Label" for="{{colSelectId}}">
          <p-multiSelect id="{{colSelectId}}" [options]="availableColumns" [(ngModel)]="selectedColumns" optionLabel="header" defaultLabel="Select Columns"
                         maxSelectedLabels="0" selectedItemsLabel="{0} column(s) selected" (change)="updateGlobalFilterFields()" class="multiselect_userColumn" styleClass="w-full" tabindex="0" aria-label="Select columns">
          </p-multiSelect>
        </label>

      </ng-template>
      <ng-container *ngTemplateOutlet="captionRightContentSuffix"></ng-container>
    </div>

  </ng-template>

  <ng-template pTemplate="colgroup" let-columns>
    <colgroup>
      <ng-container *ngTemplateOutlet="colGroupPrefix"></ng-container>
      <ng-container *ngIf="colGroupContent; then hasColGroupContent else noColGroupContent"></ng-container>
      <ng-template #hasColGroupContent>
        <ng-container *ngTemplateOutlet="colGroupContent, context: { columns:selectedColumns }"></ng-container>
      </ng-template>
      <ng-template #noColGroupContent>
        <ng-container *ngFor="let col of columns">
          <col class="{{col.fieldId}}Column" />
        </ng-container>
      </ng-template>
      <ng-container *ngTemplateOutlet="colGroupSuffix"></ng-container>
    </colgroup>
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <ng-container *ngTemplateOutlet="headerRowPrefix"></ng-container>
    <tr>
      <th pResizableColumn *ngIf="isMultiSelect" id="checkBoxColumn_{{tableId}}" style="width:3rem; text-align: center; vertical-align: middle;">
        <p-tableHeaderCheckbox id="selectAllCheckbox_{{tableId}}" [ariaLabel]="lazy ? 'Select all displayed rows' : 'Select all rows'" [pTooltip]="lazy ? 'Select all displayed rows' : 'Select all rows'" tooltipPosition="right"></p-tableHeaderCheckbox>
      </th>
      <ng-container *ngTemplateOutlet="headerRowContentPrefix"></ng-container>
      <ng-container *ngIf="headerRowContent; then hasHeaderRowContent else noHeaderRowContent"></ng-container>
      <ng-template #hasHeaderRowContent>
        <ng-container *ngTemplateOutlet="headerRowContent, context: { columns:selectedColumns }"></ng-container>
      </ng-template>

      <ng-template #noHeaderRowContent>
        <th pResizableColumn *ngFor="let col of selectedColumns" id="{{col.fieldId}}Column" [hidden]="col.hidden" role="row" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sortable" [ngClass]="!col.filter && !col.sortable ? 'grid-column-no-sort-filter': ''">
          <div class="flex justify-content-between align-content-start flex-column">
            <ng-container *ngIf="col.getTooltip; then hasTooltip else noTooltip"></ng-container>
            <ng-template #hasTooltip>
              <span id="{{col.fieldId}}Label" class="flex align-items-end mb-1"
                    [pTooltip]="col.getTooltip()"
                    [tooltipStyleClass]="col.getTooltipStyleClass"
                    [tooltipPosition]="col.getTooltipPosition"
                    [tooltipEvent]="col.getTooltipEvent">{{ col.header }}</span>
            </ng-template>
            <ng-template #noTooltip>
              <span id="{{col.fieldId}}Label" class="flex align-items-end mb-1">{{ col.header }}</span>
            </ng-template>
            <div id="{{col.fieldId}}Header" class="flex flex-row-reverse flex-nowrap align-items-center align-content-end justify-content-between">
              <div *ngIf="col.filter" id="{{uniqueId + col.fieldId}}Filter" [hidden]="col.hidden">
                <button id="{{col.field}}FilterButton" (click)="toggleOverlayPanel(overlayPanel, $event)" (keydown.tab)="tabHandler($event, col)" [attr.aria-label]="'filter by ' + col.field" class="p-column-filter-menu-button" icon="pi pi-filter">
                  <span class="pi pi-filter-icon pi-filter"></span>
                </button>
              </div>
              <p-sortIcon *ngIf="col.sortable" id="{{col.fieldId}}Sort" [field]="col.field" ariaLabel="Sort"
                          ariaLabelDesc="Sort in descending order" ariaLabelAsc="Sort in descending order">
              </p-sortIcon>
            </div>
          </div>

          <p-overlayPanel #overlayPanel styleClass="hw-fix" id="{{col.fieldId}}FilterPanel" [dismissable]="true" tabindex="0" [showCloseIcon]="true" (onShow)="showOverlayPanel($event, col)">
            <ng-container *ngIf="col.filter">
              <ng-container *ngIf="col.filter.matchMode != 'contains' && col.filter.matchMode != 'startsWith' && col.filter.matchMode != 'endsWith'; else searchFilter">
                <ng-container *ngIf="lazy && col.filter.loading; then filterLoading else filterLoaded"></ng-container>
                <ng-template #filterLoading>
                  <div id="{{col.fieldId}}FilterLoadingSpinner" tabindex="0" (keydown)="shiftTabHandler($event, col)" style="width:25px">
                    <p-progressSpinner></p-progressSpinner>
                  </div>
                </ng-template>
                <ng-template #filterLoaded>
                  <div id="{{col.fieldId}}FilterContainer" tabindex="0" (keydown)="shiftTabHandler($event, col)">
                    <p-listbox id="{{col.fieldId}}MultiValueFilter" [filter]="true" checkbox="checkbox" multiple="multiple" optionLabel="label" optionValue="value"
                               [options]="col.filter.availableValues" [(ngModel)]="col.filter.selectedValues" (onChange)="filter($event.value, col)">
                    </p-listbox>
                    <p-button id="{{col.fieldId}}ClearMultiValueFilter" styleClass="p-button-outlined p-button-sm" icon="pi pi-times"
                              type="button" role="button"
                              label="Clear selected filters"
                              (click)="filter(col.filter.selectedValues = null, col)"
                              [disabled]="!col.filter.selectedValues">
                    </p-button>
                  </div>
                </ng-template>
              </ng-container>
              <ng-template #searchFilter>
                <ng-container>
                  <input id="{{col.fieldId}}SearchFilter" type="text" pInputText size="25" placeholder="Search" [(ngModel)]="col.filter.selectedValues" (ngModelChange)="filter(col.filter.selectedValues, col)" aria-label="Search" />
                  <p-button id="{{col.fieldId}}ClearSearchFilter" styleClass="p-button-outlined p-button-sm" icon="pi pi-times"
                            type="button" role="button"
                            label="Clear filter"
                            (click)="filter(col.filter.selectedValues = null, col)"
                            [disabled]="!col.filter.selectedValues">
                  </p-button>
                </ng-container>
              </ng-template>
            </ng-container>
          </p-overlayPanel>
        </th>
      </ng-template>
      <ng-container *ngTemplateOutlet="headerRowContentSuffix"></ng-container>
    </tr>
    <ng-container *ngTemplateOutlet="headerRowSuffix"></ng-container>
  </ng-template>

  <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
    <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" id="{{rowData.rowId}}" tabindex="0">
      <td *ngIf="isMultiSelect" style="text-align: center; vertical-align:top;">
        <p-tableCheckbox [pSelectableRow]="rowData" [value]="rowData" [index]="rowIndex" [id]="tableId+'_tableCheckBoxRow_'+rowIndex" ariaLabel="Checkbox"></p-tableCheckbox>
      </td>
      <ng-container *ngTemplateOutlet="bodyRowContentPrefix; context: { rowData:rowData, rowIndex:rowIndex }"></ng-container>
      <ng-container *ngIf="bodyRowContent; then hasBodyRowContent else noBodyRowContent"></ng-container>
      <ng-template #hasBodyRowContent>
        <ng-container *ngTemplateOutlet="bodyRowContent; context: { rowData:rowData, rowIndex:rowIndex, columns:columns, selectedColumns:selectedColumns }"></ng-container>
      </ng-template>
      <ng-template #noBodyRowContent>
        <td class="{{col.align === 'right' ? 'text-right': col.align == 'center' ? 'text-center': null}}" *ngFor="let col of selectedColumns" headers="{{col.fieldId}}Column" [hidden]="col.hidden" id="{{rowData.rowId}}_{{col.fieldId}}">
          <span>{{col.formatValue(col.getValue(rowData))}}</span>
          <span class="p-column-title">{{col.header}}</span>
        </td>
      </ng-template>
      <ng-container *ngTemplateOutlet="bodyRowContentSuffix; context: { rowData:rowData, rowIndex:rowIndex }"></ng-container>
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    <ng-container *ngTemplateOutlet="footerContent;"></ng-container>
  </ng-template>

  <ng-template pTemplate="paginatorleft">
    <p-button id="{{resetFilterId}}" styleClass="p-button-text" icon="pi pi-filter-slash"
              type="button" role="button"
              label="Reset sorts &amp; filters" ariaLabel="Reset sorts and filters"
              (click)="reset()">
    </p-button>
  </ng-template>

  <ng-template pTemplate="paginatorright" let-state>
    <span class="mr-1">
      ({{state.first + 1}}-{{state.totalRecords > state.first + state.rows ? state.first + state.rows : state.totalRecords}} of {{state.totalRecords}} rows)
    </span>
  </ng-template>

  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="totalColumns || ((!columns) ? 1 : isMultiSelect ? columns.length + 1: columns.length)">
        <ng-container *ngIf="loading; then loadingEmptyMessageTemplate else loadedEmptyMessageTemplate"></ng-container>
        <ng-template #loadingEmptyMessageTemplate><span>Loading ...</span></ng-template>
        <ng-template #loadedEmptyMessageTemplate>
          <ng-container *ngIf="zeroRecordsFoundMessage; then hasZeroRecordsFoundMessage else noZeroRecordsFoundMessage"></ng-container>
          <ng-template #hasZeroRecordsFoundMessage>{{ zeroRecordsFoundMessage }}</ng-template>
          <ng-template #noZeroRecordsFoundMessage>Nothing to show!</ng-template>
        </ng-template>
      </td>
    </tr>
  </ng-template>
</p-table>
